<div class="gps-alert-box">
  <div class="img-align">
    <div class="left">
      <img src="assets/icon/Group 566.svg" alt="card-remove">
    </div>
    <div class="right">
    </div>
  </div>
  <div class="card-remove-wrapper2">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <p class="text-center">
            Turn on Location Services from Browser settings to allow "Starbucks" to determine your location.
          </p>
        </div>
        <div class="col-12 text-center mt-4">
          <button type="button" class="custom-btn btn-md-rounded btn-black" (click)="closePopup()">Close</button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 text-right">
    <img src="assets/icon/Group45.svg" alt="card-remove">
  </div>
</div>
